import ThemeOptions from './ThemeOptions';
import UserOptions from "./UserOptions";
import PageOptions from "./PageOptions";
import LeadsOptions from "./LeadsOptions";
import ProductionOptions from "./ProductionOptions";

export default {
    ThemeOptions,
    UserOptions,
    PageOptions,
    LeadsOptions,
    ProductionOptions
};